module.exports = __webpack_public_path__ + "static/media/galerija_2022_0011.0322abe3.jpg";